import React, { useEffect } from 'react'
import { MDBCard, MDBCardBody, MDBCardImage, MDBCardGroup, MDBCardText, MDBIcon, MDBTooltip, MDBBtn } from "mdb-react-ui-kit"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import { likeTour } from '../Redux/Features/tourSlice'


export default function CardTour({ imageFile, description, title, tags, _id, name, likes }) {
    const { user } = useSelector((state) => ({ ...state.auth }))
    const userId = user?.result[0]?._id || user?.result[0]?.googleId;
    const dispatch = useDispatch();
    const excerpt = (str) => {
        if (str.length > 45) {
            str = str.substring(0, 45) + "...";
        }
        return str;
    }
    const Likes = () => {
        if (likes.length > 0) {
            return likes.find((like) => like == userId) ? (
                <>
                    <MDBIcon fas icon="thumbs-up" />
                    &nbsp;
                    {likes.length > 2 ? (
                        <MDBTooltip
                            tag="a"
                            title={`You and ${likes.length - 1} other people likes`}
                        >
                            {likes.length} Likes
                        </MDBTooltip>
                    ) : (
                        `${likes.length} Like${likes.length > 1 ? "s" : ""}`
                    )}
                </>
            ) : (
                <>
                    <MDBIcon far icon="thumbs-up" />
                    &nbsp;{likes.length} {likes.length === 1 ? "Like" : "Likes"}
                </>
            );
        }
        return (
            <>
              <MDBIcon far icon="thumbs-up" />
              &nbsp;Like
            </>
          );
    }

    const handleLike = () => {
        dispatch(likeTour({ _id }));
    };

    return (
        <MDBCardGroup>
            <MDBCard className='h-100 mt-2 d-sm-flex' style={{ maxWidth: "20rem" }}>
                <MDBCardImage
                    src={imageFile}
                    alt={title}
                    position="top"
                    style={{ maxWidth: "100%", height: "100%" }}
                />
                <div className='top-left'>{name}</div>
                <span className='text-start tag-card'>{tags.map((tag) =>
                    <Link to={`/tour/tag/${tag}`}>#{tag}</Link>
                )}
                    <MDBBtn
                        style={{ float: "right" }}
                        tag="a"
                        color="none"
                        onClick={!user?.result ? null : handleLike}
                    >
                        {!user?.result ? (
                            <MDBTooltip title="Please login to like tour" tag="a">
                                <Likes />
                            </MDBTooltip>
                        ) : (
                            <Likes />
                        )}
                    </MDBBtn>
                </span>
                <MDBCardBody>
                    <MDBCardText className='text-start'>{title}</MDBCardText>
                    <MDBCardText className='text-start'>
                        {excerpt(description)}
                        <Link to={`tour/${_id}`}>Read More</Link>
                    </MDBCardText>
                </MDBCardBody>
            </MDBCard>
        </MDBCardGroup>
    )
}
